import {  serviceBuffer, servicev2 } from "@/utils/request";




export function 获取登陆用户信息(){
    return serviceBuffer({
        url: '/sys/yong_hu',
        method: 'GET',
        data: {},
    });
}